import { isoDay } from '../atendimento/atendimentoFilters';

// O filtro da aba Campanhas é o da página (`ATENDIMENTO_SCHEMA`, em
// `atendimentoFilters.js`), na barra do cabeçalho: os campos comuns, com time e
// atendente apagados aqui (o disparo não tem nenhum dos dois) e valendo nas
// outras abas, mais a campanha, o template e o segmento, que são só desta aba.

// O detalhe de uma campanha é o filtro `campanha` com exatamente uma chave
// (PLAN D8): com duas ou mais, é a visão geral delas.
export const detailKey = filters =>
  filters.campanha?.length === 1 ? filters.campanha[0] : null;

// Filtro → API (`campanhasReport.js`). Time e atendente não vão.
export const campanhasApiFilters = filters => ({
  since: isoDay(filters.period.from),
  until: isoDay(filters.period.to),
  includeTests: Boolean(filters.includeTests),
  agentId: filters.agentId,
  inboxId: filters.inboxId,
  campaignKeys: filters.campanha || [],
  templates: filters.template || [],
  segments: filters.segmento || [],
});

// O recorte das opções do filtro: o servidor as dá sem a própria escolha, e
// escolher uma campanha não as pede de novo.
export const optionsApiFilters = filters => ({
  ...campanhasApiFilters(filters),
  campaignKeys: [],
  templates: [],
  segments: [],
});
